import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { examstudentdelete, examstudentlist } from "../../../services/admin";
import moment from "moment";
import Swal from "sweetalert2";
import { studentlist, studentview } from "../../../services/student";
import { Modal } from "react-bootstrap";
export default function Allexamsubject() {
  const navigate = useNavigate();
  const [filterProduct, setFilterProduct] = useState([]);

  const columnDefs = [
    {
      headerName: "Actions",
      field: "id",
      width: 100,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() =>
                navigate(`/exam/examsubjectdetail/${params.value}`)
              }
              className="btn-sm btn-info me-2"
            >
              <i className="fa fa-edit"></i>
            </a>

            <a
              onClick={() => handleSwitch(params.value)}
              className="btn-sm btn-danger"
            >
              <i className="fa fa-trash"></i>
            </a>
          </div>
        );
      },
    },
    {
      headerName: "Exam Title",
      field: "exam_title",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Exam Date",
      field: "exam_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return moment(params.value).format("DD-MM-YYYY");
      },
    },

    {
      headerName: "Exam Time",
      field: "exam_time",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Subject",
      field: "subject_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Theory",
      field: "theory_mark",
      width: 120,
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Practical",
      field: "pratical_mark",
      width: 120,
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Class",
      field: "class_name",
      width: 120,
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Section",
      field: "section_name",
      width: 120,
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Academy",
      field: "academy_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  const columnSDefs = [
    {
      headerName: "Actions",
      field: "id",
      width: 100,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => showmark(params.data)}
              className="btn-sm btn-secondary"
            >
              <i className="fa fa-eye"></i>
            </a>
          </div>
        );
      },
    },
    {
      headerName: "Exam Title",
      field: "exam_title",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Exam Date",
      field: "exam_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return moment(params.value).format("DD-MM-YYYY");
      },
    },

    {
      headerName: "Exam Time",
      field: "exam_time",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Subject",
      field: "subject_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Theory",
      field: "theory_mark",
      width: 120,
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Practical",
      field: "pratical_mark",
      width: 120,
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Class",
      field: "class_name",
      width: 120,
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Section",
      field: "section_name",
      width: 120,
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Academy",
      field: "academy_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  const [edetail, setEDetail] = useState([]);
  const [show, setShow] = useState(false);
  function showmark(sdata) {
    setShow(true);
    setEDetail([]);
    studentlist(1).then((res) => {
      if (res.status === true) {
        const fdata = res.data.details.find((item) => item.user_id == localStorage.getItem("UID"));
        if (fdata) {
          studentview(fdata.id, moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD")).then((res) => {
            if (res.status === true) {

              const filteredData = res.data.examdetails
                .flatMap(exam => exam.details)
                .filter(item =>
                  item.exam_title_id == sdata.exam_type &&
                  item.year_id == sdata.academy_year &&
                  item.class_id == sdata.class_id &&
                  item.section_id == sdata.section
                );
              setEDetail(filteredData);
            }
          });
        }
      }
    })


  }
  function handleSwitch(list) {
    Swal.fire({
      text: "Are you sure want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        examstudentdelete(list).then((response) => {
          if (response.status === true) {
            funlist(urllink);
          }
        });
      }
    });
  }
  const [urllink, setUrl] = useState("");
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname.split("/")[2];
    setUrl(path);
    funlist(path);
  }, [location.pathname]);

  function funlist(type) {
    if (type == "listallexams") {
      examstudentlist(1, 0).then((res) => {
        if (res.status === true) {
          setFilterProduct(res.data);
        }
      });
    } else {
      examstudentlist(0, 0).then((res) => {
        if (res.status === true) {
          setFilterProduct(res.data);
        }
      });
    }
  }


  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">{urllink === "listallexams" ? "All Exams" : "Delete Exams List"}</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Exam Module</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {urllink === "listallexams" ? "All Exams" : "Delete Exams List"}
          </li>
        </ol>
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="card custom-card mg-b-20">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <h5>{urllink === "listallexams" ? "All Exams" : "Delete Exams List"}</h5>
                </div>
                <div className="col-md-6">
                  {urllink === "listallexams" && localStorage.getItem("Role") !== "4" &&
                    <div className="text-right">
                      <Link
                        className="btn btn-success me-2"
                        to="/exam/examupload"
                      >
                        Add Bulk Exam Upload
                      </Link>
                      <Link
                        className="btn btn-success"
                        to="/exam/createexamsubject"
                      >
                        Add New Exam
                      </Link>
                    </div>
                  }

                </div>
              </div>

              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={localStorage.getItem("Role") === "4" ? columnSDefs : columnDefs}
                  rowData={filterProduct}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>

              <Modal show={show} size="lg" onHide={() => setShow(false)}>
                <Modal.Header>
                  <Modal.Title>Mark List</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="col-sm-12 col-lg-12 col-xl-12">
                    <div className="exam-result-container table-wrapper">
                      {edetail.length > 0 && (
                        <div>
                          <table className="result-table">
                            <thead>
                              <tr>
                                <th>Subject</th>
                                <th>Theory Marks</th>
                                <th>Practical Marks</th>
                                <th>Min Marks</th>
                                <th>Marks Obtained</th>
                                <th>Result</th>
                              </tr>
                            </thead>
                            <tbody>
                              {edetail.map((detail, j) => {
                                const obtainedMarks = (detail.theory_mark ?? 0) + (detail.practical_mark ?? 0);
                                const totalMarks = (detail.exam_details_theory_mark ?? 0) + (detail.exam_details_pratical_mark ?? 0);

                                return (
                                  <tr key={j}>
                                    <td>{detail.subject_name} {detail.exam_date != null ? "(" + (moment(detail.exam_date).format("DD-MM-YYYY")) + ")" : ""} <br /> {detail.exam_time != null ? "(" + detail.exam_time + ")" : ""}</td>
                                    <td>{detail.exam_details_theory_mark != null ? detail.exam_details_theory_mark : ''}</td>
                                    <td>{detail.exam_details_pratical_mark != null ? detail.exam_details_pratical_mark : ''}</td>
                                    <td>{detail.pass_marks != null ? detail.pass_marks : ''}</td>
                                    <td>
                                      {obtainedMarks}
                                    </td>
                                    <td><span className={obtainedMarks >= detail.pass_marks ? "result-pass" : "result-fail"}>{obtainedMarks >= detail.pass_marks ? "Pass" : "Fail"}</span></td>

                                  </tr>
                                )
                              })}
                            </tbody>
                          </table>
                        </div>
                      )
                      }

                      {edetail.length === 0 && (
                        <div className="d-md-flex ms-auto mb-2">
                          <label className="my-auto pt-2 exam-title"><strong>No Record Found</strong></label>
                        </div>
                      )}

                    </div>

                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <a className="btn btn-danger" variant="secondary" onClick={() => setShow(false)}>
                    Close
                  </a>
                </Modal.Footer>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
